import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../AllState.css";
// import { Helmet } from "react-helmet";
import { statesData } from "../components/statesData";
import {
  FaIndustry,
  FaCheckCircle,
  FaTruck,
  FaRupeeSign,
} from "react-icons/fa";

const StatePage = () => {
  const { stateName, cityName } = useParams();
  const navigate = useNavigate();

  const [searchCity, setSearchCity] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);

  // READ MORE STATE
  const [showAllCities, setShowAllCities] = useState(false);

  // FORMAT
  const formatName = (name) =>
    name
      ?.split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  const formattedState = formatName(stateName);

  // FIND STATE
  const currentState = statesData.find(
    (s) => s.name.toLowerCase().replace(/\s+/g, "-") === stateName
  );

  // ALL CITIES
  const allCities = statesData.flatMap((state) =>
    state.cities.map((city) => ({
      name: city,
      state: state.name,
      stateSlug: state.name.toLowerCase().replace(/\s+/g, "-"),
    }))
  );

  // SELECT CITY
  useEffect(() => {
    if (cityName) {
      const foundCity = currentState?.cities.find(
        (c) => c.toLowerCase().replace(/\s+/g, "-") === cityName
      );
      setSelectedCity(foundCity);
    } else {
      setSelectedCity(null);
    }
  }, [cityName, currentState]);

  // FILTER CITY
  const filteredCities = searchCity
    ? allCities.filter((city) =>
        city.name.toLowerCase().includes(searchCity.toLowerCase())
      )
    : currentState
    ? currentState.cities.map((city) => ({
        name: city,
        state: currentState.name,
        stateSlug: stateName,
      }))
    : [];

  return (
    <div className="state-page">
      {/* HERO */}
      <section className="state-hero">
        <h2>
          Kitchens Hardware in{" "}
          {selectedCity
            ? `${selectedCity}, ${formattedState}`
            : formattedState}
        </h2>
      </section>

      <div className="layout">
        {/* SIDEBAR */}
        <div className="sidebar">
          <h3>City</h3>

          <input
            type="text"
            placeholder="Search city..."
            value={searchCity}
            onChange={(e) => setSearchCity(e.target.value)}
          />

          {/* CITY LIST */}
          <div className="city-list">
            {(showAllCities
              ? filteredCities
              : filteredCities.slice(0, 4)
            ).map((cityObj, i) => (
              <div
                key={i}
                className={`city-item ${
                  selectedCity === cityObj.name ? "active" : ""
                }`}
                onClick={() =>
                  navigate(
                    `/hardware-in/${cityObj.stateSlug}/${cityObj.name
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`
                  )
                }
              >
                {cityObj.name}
                {searchCity && ` (${cityObj.state})`}
              </div>
            ))}

            {/* READ MORE BUTTON */}
            {filteredCities.length > 4 && (
              <button
                className="read-more-btn"
                onClick={() => setShowAllCities(!showAllCities)}
              >
                {showAllCities ? "Read Less" : "Read More"}
              </button>
            )}
          </div>
        </div>

        {/* CONTENT */}
        <div className="content">
          {!selectedCity ? (
            <>
              <h2>Select a City</h2>

              <div className="city-grid">
                {filteredCities.map((cityObj, i) => (
                  <div
                    key={i}
                    className="city-card"
                    onClick={() =>
                      navigate(
                        `/hardware-in/${cityObj.stateSlug}/${cityObj.name
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`
                      )
                    }
                  >
                    {cityObj.name}
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <h2>Our Hardware Products in {selectedCity}</h2>

              <p className="sub-text">
                Discover a wide range of premium quality hardware products
                available in <strong>{selectedCity}</strong>. We specialize in
                providing durable, stylish, and modern hardware solutions for
                homes, offices, and commercial spaces. Our product range
                includes high-performance hinges, smooth drawer channels, and
                innovative kitchen accessories designed to enhance functionality
                and aesthetics.
              </p>

              {/* PRODUCTS */}
              <div className="product-grid">
                <div
                  className="product-card"
                  onClick={() => navigate("/cabinet-hinges")}
                >
                  <h3>Hinges</h3>
                  <p>Smooth and durable cabinet hinges.</p>
                </div>

                <div
                  className="product-card"
                  onClick={() => navigate("/telescopic-channel")}
                >
                  <h3>Drawer Channels</h3>
                  <p>High quality sliding drawer systems.</p>
                </div>

                <div
                  className="product-card"
                  onClick={() => navigate("/kitchen-Accessories")}
                >
                  <h3>Kitchen Accessories</h3>
                  <p>Modern accessories for smart kitchens.</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* PROCESS */}
      {selectedCity && (
        <section className="process-section">
          <h2 className="process-title">
            How We Deliver Quality Across India
          </h2>

          <div className="process-container">
            <div className="process-step">
              <div className="circle">1</div>
              <h3>Manufacturing</h3>
            </div>

            <div className="process-step">
              <div className="circle">2</div>
              <h3>Quality Check</h3>
            </div>

            <div className="process-step">
              <div className="circle">3</div>
              <h3>Packaging</h3>
            </div>

            <div className="process-step">
              <div className="circle">4</div>
              <h3>Delivery</h3>
            </div>
          </div>
        </section>
      )}

      {/* WHY US */}
      <section className="why-section">
        <h2 className="why-title">Why Choose Us</h2>

        <div className="why-container">
          <div className="why-card">
            <div className="why-icon">
              <FaIndustry />
            </div>
            <h3>Own Manufacturing</h3>
            <p>We produce high quality hardware with strict standards.</p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaCheckCircle />
            </div>
            <h3>Quality Assured</h3>
            <p>Every product goes through multiple quality checks.</p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaTruck />
            </div>
            <h3>Fast Delivery</h3>
            <p>Quick and reliable delivery across India.</p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaRupeeSign />
            </div>
            <h3>Best Pricing</h3>
            <p>Affordable pricing without compromising quality.</p>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="trust-section">
        <div className="trust-container">
          <div className="trust-box">
            <h2>10K+</h2>
            <p>Happy Customers</p>
          </div>

          <div className="trust-box">
            <h2>500+</h2>
            <p>Projects Completed</p>
          </div>

          <div className="trust-box">
            <h2>50+</h2>
            <p>Cities Served</p>
          </div>

          <div className="trust-box">
            <h2>15+</h2>
            <p>Years Experience</p>
          </div>
        </div>
      </section>

      {/* SERVICE */}
      <section className="service-area">
        <div className="container">
          <h2>Trusted Across Multiple Cities</h2>

          <p className="subtitle">
            We proudly supply our premium quality products across various cities
            with a strong commitment to excellence.
          </p>

          <p className="description">
            Our products are trusted by a large number of satisfied customers.
            We focus on delivering top-quality materials, reliable service, and
            timely delivery.
          </p>
        </div>
      </section>
    </div>
  );
};

export default StatePage;